"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Cohort () {
        return Cohort;
    },
    get GetCohortsResponse () {
        return GetCohortsResponse;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const Cohort = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    description: _zod.z.string().optional(),
    type: _zod.z.string().optional(),
    createdAt: _zod.z.any().optional(),
    updatedAt: _zod.z.any().optional(),
    color: _zod.z.string().optional(),
    memberCount: _zod.z.number(),
    archivedAt: _zod.z.any().optional(),
    archivedBy: _zod.z.any().optional(),
    calculation_status: _zod.z.string().optional()
});
const GetCohortsResponse = _zod.z.object({
    cohorts: _zod.z.array(Cohort),
    currentCohortCount: _zod.z.number(),
    maximumAllowedCohorts: _zod.z.number()
});
